((w, d) => {
    const header = d.querySelector('.Header');
    const search = d.querySelector('.HeaderSearch');
    function closeSearch(button) {
        header.classList.remove('Header--open');
        button.setAttribute('aria-expanded', false);
    }
    function openSearch(button) {
        header.classList.add('Header--open');
        button.setAttribute('aria-expanded', true);
        search.querySelector('input').focus();
    }
    function toggleButton(button) {
        const exp = button.getAttribute('aria-expanded') === 'true';
        if (exp) {
            closeSearch(button);
        } else {
            openSearch(button);
        }
    }

    const button = d.querySelector('.HeaderSearch__expand');

    d.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
            if (search.contains(e.target)) {
                closeSearch(button);
                button.focus();
            }
        }
    });

    d.addEventListener('click', (e) => {
        if (!search.contains(e.target)) {
            closeSearch(button);
        }
    });

    button.addEventListener('click', () => {
        toggleButton(button);
    });
})(window, document);
